import React, { ReactNode } from 'react';
import { styles } from './InfoCard.css';

export type InfoCardProps = {
  children?: ReactNode;
  type: 'info' | 'warning';
};

const InfoCard = ({ children, type }: InfoCardProps): JSX.Element => {
  const isWarning = type === 'warning';
  return <div className={styles.root({ isWarning })}>{children}</div>;
};

export default InfoCard;
